import { useState } from "react";
import { getGigDetails } from "../../services/gig-service";
import { ToggleBox } from "../toggleBox";
import * as gigService from "../../../src/services/gig-service";
import { useToast } from "../../context/toast";
import ConfirmModal from "../confirmModal";

export const JobItem = (props: any) => {
  const { notify } = useToast();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const getFormattedDate = (date: string) => {
    return new Date(date).toLocaleDateString("ro-RO", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  const isExpired = () =>
    !!props.dateTo && new Date(props.dateTo) < new Date();

  const getStatus = (isEnabled: boolean | null) => {
    if (isEnabled == null || !isEnabled || isExpired()) return "Inactiv";
    return "Activ";
  };

  const handleDelete = async () => {
    setDeleting(true);
    const response = await gigService.deleteGig(props.id);
    setDeleting(false);
    if (response.ok) {
      setShowDeleteModal(false);
      notify("Job-ul a fost șters cu succes!", "success");
      props.onChanged?.();
    } else {
      notify("Eroare la ștergere!", "error");
    }
  };

  const toggleJobStatus = async () => {
    if (isExpired()) {
      notify("Nu poți reactiva acest job deoarece data de încheiere a trecut. Editează job-ul cu o dată nouă.", "error");
      return;
    }

    const updateGigRequest: gigService.UpdateGigRequest = {};

    if (props.status || props.status == null) {
      updateGigRequest.enabled = false;
    } else {
      updateGigRequest.enabled = true;
    }

    const formData = new FormData();
    formData.append(
      "body",
      new Blob([JSON.stringify(updateGigRequest)], { type: "application/json" })
    );

    let response = await gigService.updateGigDetails(formData, props.id);

    if (response.ok) {
      notify("Statusul a fost schimbat cu succes!", "success");
      props.onChanged?.();
    } else {
      let errorMsg = "A apărut o eroare. Te rugăm să contactezi suportul.";
      try {
        const body = await response.json();
        if (body?.["error-message"]) errorMsg = body["error-message"];
      } catch {}
      notify(errorMsg, "error");
    }
  };

  const getFormattedPrice = () => {
    if (props.confidentialRate || props.rate == null) return "Confidențial";
    if (props.rateType === "DAY") return `${props.rate} Lei / Zi`;
    if (props.rateType === "HOUR") return `${props.rate} Lei / Oră`;
    if (props.rateType === "GROSS") return `${props.rate} Lei brut`;
    if (props.rateType === "NET") return `${props.rate} Lei net`;
    return `${props.rate} Lei`;
  };

  return (
    <div className="candidate-item  mt-[16px] cursor-pointer" id={props.id}>
      <div className="flex justify-between">
        <div className="flex" onClick={props.onClickAction}>
          <div className="w-[64px] h-[64px] rounded-full overflow-hidden flex-shrink-0 bg-figmaSpecialBlue bg-opacity-25 flex items-center justify-center">
            {props?.thumbnail != null ? (
              <img
                src={props.thumbnail}
                className="w-full h-full object-cover"
              />
            ) : (
              <p className="font-semibold">{props.title[0]}</p>
            )}
          </div>
          <div className="ml-[16px]">
            <div className="flex items-center gap-2">
              <p className="candidate-item-job-title">{props.title}</p>
              {props.eventId && (
                <span className="text-[10px] font-semibold text-figmaPrimary bg-blue-50 border border-figmaPrimary rounded-full px-2 py-0.5 whitespace-nowrap">
                  {props.eventName ?? "Eveniment"}
                </span>
              )}
            </div>
            <p className="text-figmaPrimary text-[12px]">{props.location}</p>
            <div className="flex mt-[8px] items-center">
              <div className="flex items-center">
                <img src="/images/calendar-icon.svg" />
                <p className="text-figmaDarkGray text-[12px] pl-[4px]">
                  {getFormattedDate(props.startDate)}
                </p>
              </div>
              <div className="ml-[8px] flex items-center">
                <img src="/images/ic-dollar.svg" />
                <p className="text-figmaDarkGray text-[12px] pl-[4px]">
                  {getFormattedPrice()}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <p className="candidate-item-rating">
            {getStatus(props.status)}
          </p>
          <div className="flex items-center gap-3 mt-[16px]">
            <button
              onClick={(e) => { e.stopPropagation(); setShowDeleteModal(true); }}
              className="text-figmaDarkGray hover:text-figmaContrast transition-colors"
              title="Șterge job"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
              </svg>
            </button>
            <ToggleBox
              isChecked={props.status && !isExpired()}
              onColor="#FF3366"
              onToggle={toggleJobStatus}
            />
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={showDeleteModal}
        title="Șterge job"
        message="Ești sigur că vrei să ștergi acest job? Acțiunea nu poate fi anulată."
        confirmText="Șterge"
        cancelText="Anulează"
        loading={deleting}
        tone="danger"
        onConfirm={handleDelete}
        onCancel={() => setShowDeleteModal(false)}
      />
    </div>
  );
};
